import gsap from 'gsap';

export default {
   init() {
      const locationsList = document.querySelector('.locations-list');
      const locationItems = document.querySelectorAll('.location-item');
      const categoryName = document.querySelector('.category-name');

      document.querySelectorAll('.label-dropdown').forEach(label => {
         label.addEventListener('click', () => {
            const parent = label.closest('.aura-filter-locations-interest__inner');
            if (parent) parent.classList.toggle('actived');
         });
      });

      document.querySelectorAll('.aura-filter-locations-interest__inner ul.list-dropdown li')
         .forEach(item => {
            item.addEventListener('click', () => {

               const selectedCategory = item.getAttribute('data-value');
               const selectedCategoryText = item.textContent;

               // update title
               if (categoryName) {
                  categoryName.textContent = selectedCategoryText;
               }

               // close dropdown
               const parent = item.closest('.aura-filter-locations-interest__inner');
               if (parent) parent.classList.remove('actived');

               // hide all
               locationItems.forEach(el => {
                  gsap.set(el, { display: 'none', opacity: 0 });
               });

               let visibleCount = 0;

               // filter + animate
               locationItems.forEach(el => {
                  const locationCategory = el.getAttribute('data-category');

                  if (!selectedCategory || locationCategory === selectedCategory) {

                     gsap.set(el, { display: 'block' });

                     gsap.fromTo(
                        el,
                        {
                           opacity: 0,
                           y: 10,
                        },
                        {
                           opacity: 1,
                           y: 0,
                           duration: 0.5,
                           ease: 'power1.out',
                           delay: visibleCount * 0.2
                        }
                     );

                     visibleCount++;
                  }
               });
            });
         });
   }
}